import { MsalProvider } from "@azure/msal-react";

import { AuthContext } from "./AuthContext";
import { AuthError, AuthLoading } from "./AuthUi";
import { useAuthBootstrap } from "./hooks/useAuthBootstrap";

const AuthProvider = ({ children }) => {
    const value = useAuthBootstrap();

    if (!value.isReady) {
        return <AuthLoading />;
    }

    if (value.error) {
        return <AuthError error={value.error} />;
    }

    if (!value.instance) {
        return <AuthLoading />;
    }

    return (
        <AuthContext.Provider value={value}>
            <MsalProvider instance={value.instance}>{children}</MsalProvider>
        </AuthContext.Provider>
    );
};

export default AuthProvider;
